import React, { useState } from 'react'
import abcjs from 'abcjs';
import ShowAbcTune from './ShowAbcTune';
import { SlSizeFullscreen } from 'react-icons/sl';


// Adds "X:1" to the beginning of the abc string if it doesn't exist
// abc_parse_book.js needs "X:" as tunebook tune delimiter
const addAbcjsTuneDelimter = (abcInputs: string[]) => (
  abcInputs.map(abcInputs => {
    if (!abcInputs.includes('X:')) {
      abcInputs = 'X:1\n' + abcInputs
    }
  }))

export default function ShowAbcApp() {
  const queryParameters = new URLSearchParams(window.location.search)
  const paramsAbc = queryParameters.get('abc') || ''
  const tuneBook = new abcjs.TuneBook(paramsAbc)
  const [size, setSize] = useState<'sm' | 'md' | 'lg'>('md')

  const x = tuneBook.tunes

  const sizeStyle = {
    sm: '550px',
    md: '750px',
    lg: '950px'
  }[size]

  console.log(sizeStyle);
  return (

    <div style={{ maxWidth: sizeStyle, margin: '0 auto' }} >
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '20px', marginBottom: '10px', fontWeight: 'bold' }}>
        <div onClick={(e) => setSize('sm')} style={{ fontSize: '20px', color: size == 'sm' ? 'fuchsia' : '', cursor: 'pointer' }}><SlSizeFullscreen /></div>
        <div onClick={(e) => setSize('md')} style={{ fontSize: '30px', color: size == 'md' ? 'fuchsia' : '', cursor: 'pointer' }}><SlSizeFullscreen /></div>
        <div onClick={(e) => setSize('lg')} style={{ fontSize: '38px', color: size == 'lg' ? 'fuchsia' : '', cursor: 'pointer' }}><SlSizeFullscreen /></div>
      </div>
      {tuneBook.tunes.map(
        tune => (
          <ShowAbcTune analyzedTune={tune} />
        ))
      }

      <p> <b>Troubleshooting:</b> </p>
      <ul>
        <li>
          Can't hear the music on iPhone?
          <ul>
            <li>
              Try turning off "Silent Mode" (the switch on the side of the phone).
            </li>
          </ul>
        </li>
      </ul>
    </div >
  )
}